import React from "react";
import { Create, translate } from "react-admin";
import BillForm from "./BillForm";

const AnnounceTitle = ({ translate }) => {
  return <span>{`สร้าง${translate("bill.bill")}`}</span>;
};

const Title = translate(AnnounceTitle);

export const BillCreate = props => (
  <Create title={<Title />} {...props}>
    <BillForm />
  </Create>
);



// WEBPACK FOOTER //
// ./src/components/bill/BillCreate.js